import {
  CampaignBody,
  TextSearchCampaignPropertiesImageWeights,
  TextSearchCampaignPropertiesProductWeights,
} from "@vviinn/user-managment-client-ts";
import { TextSearchNumbericTitlesKey, TypecastedTextSearchData } from "./types";
import { textCampaignWeightsKeys } from "./constants";

function typecastData<T>(
  data: TypecastedTextSearchData<T>,
  isSameValue?: boolean,
) {
  const { typecastedEntity, typecastedKey } = data;
  if (isSameValue && typecastedEntity) delete typecastedEntity[typecastedKey];
  return {
    ...data,
    value: typecastedEntity ? typecastedEntity[typecastedKey] : undefined,
  };
}

export const typecastedTextSearch = (
  key: TextSearchNumbericTitlesKey,
  grandParent?: CampaignBody,
  isSameValue?: boolean,
) => {
  const parentKey = textCampaignWeightsKeys[key];
  const parentEntity = grandParent?.[parentKey];
  const textData = {
    typecastedEntity: parentEntity,
    typecastedKey: key,
  };

  const typecastedData =
    parentKey === "imageWeights"
      ? typecastData<TextSearchCampaignPropertiesImageWeights>(
          textData as TypecastedTextSearchData<TextSearchCampaignPropertiesImageWeights>,
          isSameValue,
        )
      : typecastData<TextSearchCampaignPropertiesProductWeights>(
          textData as TypecastedTextSearchData<TextSearchCampaignPropertiesProductWeights>,
          isSameValue,
        );

  return {
    parentKey,
    ...typecastedData,
  };
};
